function getTreeCoordinates (treeKey) {
  const coords = treeKey.split(';')

  return {
    columnTreeCode: coords[0],
    rowTreeCode: coords[1]
  }
}

function getTreeKey (columnTreeCode, rowTreeCode) {
  return `${columnTreeCode || ''};${rowTreeCode || ''}`
}

export {
  getTreeCoordinates,
  getTreeKey
}



// WEBPACK FOOTER //
// ./src/utils/getTreeCoordinates.js